import styled, { css, DefaultTheme } from 'styled-components';

export const Container = styled.div`
  width: 100%;
  position: relative;

  .error-wrapper {
    margin-left: 16px;
  }

  .error-message {
    color: red;
    text-align: left;
  }
`;

interface SelectWrapperProps {
  focus?: boolean;
  error?: boolean;
}

export const Label = styled.label<SelectWrapperProps>`
  ${({ error, theme }) => css`
    position: absolute;
    top: -8px;
    left: 16px;
    font-weight: 500;
    font-size: 12px;
    background-color: var(--background-color);
    padding: 0 1px;
    color: ${error ? theme.colors.colorDanger : theme.colors.blueEinstein};
  `}
`;

const SelectWrapperModifiers = {
  error: (theme: DefaultTheme) => css`
    border-color: ${theme.colors.colorDanger};
  `,
  focus: (theme: DefaultTheme) => css`
    border-color: ${theme.colors.blueEinstein};
  `
};

export const SelectWrapper = styled.div<SelectWrapperProps>`
  ${({ focus, theme, error }) => css`
    display: flex;
    align-items: center;

    height: 56px;
    width: 100%;
    color: #555658;
    background: #fff;
    outline: 0;
    border: 1px solid;
    border-color: ${theme.colors.colorGray300};
    border-radius: 8px;
    cursor: pointer;

    ${error && SelectWrapperModifiers.error(theme)}
    ${focus && SelectWrapperModifiers.focus(theme)}
  `}

  .image {
    width: 24px;
    height: 24px;
    margin: 16px;
    margin-left: auto;
  }
`;

export const SelectText = styled.p`
  margin-left: 16px;
  font-size: 16px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;

  .placeholder-text {
    color: #898b8e;
    opacity: 0.55;
  }
`;

export const OptionsWrapper = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: flex-start;

  margin-top: 8px;
  padding: 0 16px;

  color: #555658;
  background: #fff;
  outline: 0;
  border: 1px solid #d5d5d6;
  border-radius: 8px;
`;

export const Option = styled.div`
  .option-text {
    font-size: 16px;
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
  }

  padding: 16px 0;
  cursor: pointer;
  width: 100%;

  & + & {
    border-top: 1px solid #d5d5d6;
  }
`;
